import axios from "axios";
import { adnPageSize } from "../components/common/GeneralConfigurations";
import { baseApiUrl, httpRequest, getHttpHeaders, getHttpHeadersExcel } from "./ApiUtils";

const employeeApiUrl = `${baseApiUrl}/api/Employees`;

export const getEmployees = async (
    pageNumber = 1,
    pageSize = adnPageSize,
    orderBy = "",
    name = "",
    email = "",
    contractType = -1,
    carrearLevel = 0,
    isConsultant = "",
    isHired = false,
    number = "",
    phone = "",
    gender = "",
    nationalityId = 0,
    workPlaceId = 0,
    managerId = [],
    currentCompany = "",
    referenceBy = "",
    startBirthDate = "",
    endBirthDate = "",
    startAdmissionDate = "",
    endAdmissionDate = "",
    startAdmissionCTIDate = "",
    endAdmissionCTIDate = "",
    startResignationDate = "",
    endResignationDate = "",
    hasCorpDone = false,
    hasInquirySent = false,
    hasIntegrationEmailSent = false,
    hasProfileEmailSent = false,
    hasAssessmentSent = false,
    primaveraDepartmentId = "",
    dismissalComment = ""
) => {
    return await httpRequest(
        fetchEmployees.bind(
            this,
            pageNumber,
            pageSize,
            orderBy,
            name,
            email,
            contractType,
            carrearLevel,
            isConsultant,
            isHired,
            number,
            phone,
            gender,
            nationalityId,
            workPlaceId,
            managerId,
            currentCompany,
            referenceBy,
            startBirthDate,
            endBirthDate,
            startAdmissionDate,
            endAdmissionDate,
            startAdmissionCTIDate,
            endAdmissionCTIDate,
            startResignationDate,
            endResignationDate,
            hasCorpDone,
            hasInquirySent,
            hasIntegrationEmailSent,
            hasProfileEmailSent,
            hasAssessmentSent,
            primaveraDepartmentId,
            dismissalComment
        )
    );
};

const fetchEmployees = async (
    pageNumber,
    pageSize,
    orderBy,
    name,
    email,
    contractType,
    carrearLevel,
    isConsultant,
    isHired,
    number,
    phone,
    gender,
    nationalityId,
    workPlaceId,
    managerId,
    currentCompany,
    referenceBy,
    startBirthDate,
    endBirthDate,
    startAdmissionDate,
    endAdmissionDate,
    startAdmissionCTIDate,
    endAdmissionCTIDate,
    startResignationDate,
    endResignationDate,
    hasCorpDone,
    hasInquirySent,
    hasIntegrationEmailSent,
    hasProfileEmailSent,
    hasAssessmentSent,
    primaveraDepartmentId,
    dismissalComment
) => {
    const managerIdQueries = managerId.map(managerId => `ManagerId=${managerId}`).join('&');

    let config = getHttpHeaders();
    return await axios.get(
        `${employeeApiUrl}?Name=${name}&ContractTypeId=${contractType}&OrderBy=${orderBy}&PageNumber=${pageNumber}&PageSize=${pageSize}&CarrearLevelId=${carrearLevel}&IsConsultant=${isConsultant}&Email=${email}&isHired=${isHired}&number=${number}&phone=${phone}&gender=${gender}&nationalityId=${nationalityId}&workPlaceId=${workPlaceId}&${managerIdQueries}&currentCompany=${currentCompany}&ReferenceBy=${referenceBy}&StartBirthDate=${startBirthDate}&EndBirthDate=${endBirthDate}&startAdmissionDate=${startAdmissionDate}&endAdmissionDate=${endAdmissionDate}&startAdmissionCTIDate=${startAdmissionCTIDate}&endAdmissionCTIDate=${endAdmissionCTIDate}&startResignationDate=${startResignationDate}&endResignationDate=${endResignationDate}&hasIntegrationEmailSent=${hasIntegrationEmailSent}&hasProfileEmailSent=${hasProfileEmailSent}&hasAssessmentSent=${hasAssessmentSent}&hasInquirySent=${hasInquirySent}&hasCorpDone=${hasCorpDone}&primaveraDepartmentId=${primaveraDepartmentId}&dismissalComment=${dismissalComment}`,
        config
    );
};

export const getEmployeesWithEvents = async (
    pageNumber = 1,
    pageSize = adnPageSize,
    orderBy = "",
    name = "",
    email = "",
    contractType = "",
    carrearLevel = "",
    isConsultant = true,
    eventType = "",
    searchDoneBy,
    isdone,
    month,
    year
) => {
    return await httpRequest(
        fetchEmployeesWithEvents.bind(
            this,
            pageNumber,
            pageSize,
            orderBy,
            name,
            email,
            contractType,
            carrearLevel,
            isConsultant,
            eventType,
            searchDoneBy,
            isdone ?? "",
            month,
            year
        )
    );
};

const fetchEmployeesWithEvents = async (
    pageNumber,
    pageSize,
    orderBy,
    name,
    email,
    contractType,
    carrearLevel,
    isConsultant,
    eventType,
    searchDoneBy,
    isdone,
    month,
    year
) => {
    let config = getHttpHeaders();
    return await axios.get(
        `${employeeApiUrl}/WithEvents?Name=${name}&ContractTypeId=${contractType}&OrderBy=${orderBy}&PageNumber=${pageNumber}&PageSize=${pageSize}&CarrearLevelId=${carrearLevel}&IsConsultant=${isConsultant}&Email=${email}&EventTypeName=${eventType}&UserName=${searchDoneBy}&Done=${isdone}&Month=${month}&Year=${year}`,
        config
    );
};

export const getEmployeeById = async (id) => {
    return await httpRequest(fetchEmployeeById.bind(this, id));
};

const fetchEmployeeById = async (id) => {
    let config = getHttpHeaders();
    return await axios.get(`${employeeApiUrl}/${id}`, config);
};

export const getCareerLevels = async () => {
    return await httpRequest(fetchCareerLevels.bind(this));
};

const fetchCareerLevels = async () => {
    let config = getHttpHeaders();
    return await axios.get(`${employeeApiUrl}/CarrearLevels`, config);
};

export const getContractTypes = async () => {
    return await httpRequest(fetchContractTypes.bind(this));
};

const fetchContractTypes = async () => {
    let config = getHttpHeaders();
    return await axios.get(`${employeeApiUrl}/ContractTypes`, config);
};

export const GetContractTypeById = async (id) => {
    return await httpRequest(fetchContractProposalById.bind(this, id));
};

const fetchContractProposalById = async (id) => {
    let config = getHttpHeaders();
    return await axios.get(`${employeeApiUrl}/ContractType/${id}`, config);
};

export const GetCareerLevelById = async (id) => {
    return await httpRequest(fetchCareerLevelById.bind(this, id));
};

const fetchCareerLevelById = async (id) => {
    let config = getHttpHeaders();
    return await axios.get(`${employeeApiUrl}/CarrearLevel/${id}`, config);
};

export async function addEmployee(newEmployee) {
    return await httpRequest(postEmployee.bind(this, newEmployee));
}

async function postEmployee(newEmployee) {
    let config = getHttpHeaders();
    return await axios.post(`${employeeApiUrl}`, newEmployee, config);
}

export async function updateEmployee(updatedEmployee) {
    return await httpRequest(putEmployee.bind(this, updatedEmployee));
}

async function putEmployee(updatedEmployee) {
    let config = getHttpHeaders();
    return await axios.put(`${employeeApiUrl}`, updatedEmployee, config);
}

export async function updateInquiry(updatedInquiry) {
    return await httpRequest(putInquiry.bind(this, updatedInquiry));
}

async function putInquiry(updatedInquiry) {
    let config = getHttpHeaders();
    return await axios.put(
        `${employeeApiUrl}/SendInquiry`,
        updatedInquiry,
        config
    );
}

export async function updateEmployeeInquiryResponses(updatedEmployee) {
    return await httpRequest(
        putEmployeeInquiryResponses.bind(this, updatedEmployee)
    );
}

async function putEmployeeInquiryResponses(updatedEmployee) {
    let config = getHttpHeaders();
    return await axios.put(
        `${employeeApiUrl}/UpdateInquiry`,
        updatedEmployee,
        config
    );
}
export async function getEmployeeCounters() {
    return await httpRequest(fetchEmployeeCounters.bind(this));
}

async function fetchEmployeeCounters() {
    let config = getHttpHeaders();

    return await axios.get(`${employeeApiUrl}/Counters`, config);
}
export async function getEmployeeImageById(id) {
    return await httpRequest(fetchEmployeeImageById.bind(this, id));
}

async function fetchEmployeeImageById(id) {
    let config = getHttpHeaders();
    return await axios.get(`${employeeApiUrl}/${id}/Image`, config);
}

export async function updateEmployeeImage(data) {
    return await httpRequest(putEmployeeImage.bind(this, data));
}

async function putEmployeeImage(data) {
    let config = getHttpHeaders();
    return await axios.put(`${employeeApiUrl}/Image`, data, config);
}

export async function updateIntegration(updatedIntegration) {
    return await httpRequest(putIntegration.bind(this, updatedIntegration));
}

async function putIntegration(updatedIntegration) {
    let config = getHttpHeaders();
    return await axios.put(
        `${employeeApiUrl}/SendIntegration`,
        updatedIntegration,
        config
    );
}

export async function updateProfileEmail(updateProfile) {
    return await httpRequest(putProfileEmail.bind(this, updateProfile));
}

async function putProfileEmail(updateProfile) {
    let config = getHttpHeaders();
    return await axios.put(
        `${employeeApiUrl}/SendProfile`,
        updateProfile,
        config
    );
}

export async function updateFirstMonthAssessmentEmail(
    updateFirstMonthAssessment,
    questionType
) {
    return await httpRequest(
        putFirstMonthAssessmentEmail.bind(
            this,
            updateFirstMonthAssessment,
            questionType
        )
    );
}

async function putFirstMonthAssessmentEmail(
    updateFirstMonthAssessment,
    questionType
) {
    let config = getHttpHeaders();
    return await axios.put(
        `${employeeApiUrl}/SendFirstMonthAssessment?QuestionType=${questionType}`,
        updateFirstMonthAssessment,
        config
    );
}

export async function getNewEmployees(lastDays = "", resign = false) {
    return await httpRequest(fetchNewEmployees.bind(this, lastDays, resign));
}

async function fetchNewEmployees(lastDays, resign) {
    let config = getHttpHeaders();
    return await axios.get(
        `${employeeApiUrl}/NewConsultants?lastDays=${lastDays}&resign=${resign}`,
        config
    );
}

export async function getEmployeeByAssessmentToken(token) {
    return await httpRequest(fetchEmployeeByAssessmentToken.bind(this, token));
}

async function fetchEmployeeByAssessmentToken(token) {
    let config = getHttpHeaders();

    return await axios.get(
        `${employeeApiUrl}/FirstMonthAssessment?Token=${token}`,
        config
    );
}

export async function getConsultantsInAndOutReport() {
    return await httpRequest(fetchConsultantsInAndOutExcel.bind(this));
}
async function fetchConsultantsInAndOutExcel() {
    let config = getHttpHeadersExcel();
    return await axios.get(`${employeeApiUrl}/consultantsInAndOut?`, config);
}

export async function getEmployeeByName(name) {
    return await httpRequest(fetchEmployeeByName.bind(this, name));
}
async function fetchEmployeeByName(name) {
    let config = getHttpHeaders();
    return await axios.get(`${employeeApiUrl}/Name?name=${name}`, config);
}

export const getEmployeesExcel = async (
    pageNumber = 1,
    pageSize = adnPageSize,
    orderBy = "",
    name = "",
    email = "",
    contractType = -1,
    carrearLevel = 0,
    isConsultant = "",
    isHired = false,
    number = "",
    phone = "",
    gender = "",
    nationalityId = 0,
    workPlaceId = 0,
    managerId = [],
    currentCompany = "",
    referenceBy = "",
    startBirthDate = "",
    endBirthDate = "",
    startAdmissionDate = "",
    endAdmissionDate = "",
    startAdmissionCTIDate = "",
    endAdmissionCTIDate = "",
    startResignationDate = "",
    endResignationDate = "",
    hasCorpDone = false,
    hasInquirySent = false,
    hasIntegrationEmailSent = false,
    hasProfileEmailSent = false,
    hasAssessmentSent = false,
    primaveraDepartmentId = "",
    dismissalComment = ""
) => {
    return await httpRequest(
        fetchEmployeesExcel.bind(
            this,
            pageNumber,
            pageSize,
            orderBy,
            name,
            email,
            contractType,
            carrearLevel,
            isConsultant,
            isHired,
            number,
            phone,
            gender,
            nationalityId,
            workPlaceId,
            managerId,
            currentCompany,
            referenceBy,
            startBirthDate,
            endBirthDate,
            startAdmissionDate,
            endAdmissionDate,
            startAdmissionCTIDate,
            endAdmissionCTIDate,
            startResignationDate,
            endResignationDate,
            hasCorpDone,
            hasInquirySent,
            hasIntegrationEmailSent,
            hasProfileEmailSent,
            hasAssessmentSent,
            primaveraDepartmentId,
            dismissalComment
        )
    );
};
const fetchEmployeesExcel = async (
    pageNumber,
    pageSize,
    orderBy,
    name,
    email,
    contractType,
    carrearLevel,
    isConsultant,
    isHired,
    number,
    phone,
    gender,
    nationalityId,
    workPlaceId,
    managerId,
    currentCompany,
    referenceBy,
    startBirthDate,
    endBirthDate,
    startAdmissionDate,
    endAdmissionDate,
    startAdmissionCTIDate,
    endAdmissionCTIDate,
    startResignationDate,
    endResignationDate,
    hasCorpDone,
    hasInquirySent,
    hasIntegrationEmailSent,
    hasProfileEmailSent,
    hasAssessmentSent,
    primaveraDepartmentId,
    dismissalComment
) => {
    const managerIdQueries = managerId.map(managerId => `ManagerId=${managerId}`).join('&');

    let config = getHttpHeadersExcel();
    return await axios.get(
        `${employeeApiUrl}/EmployeesExcel?Name=${name}&ContractTypeId=${contractType}&OrderBy=${orderBy}&PageNumber=${pageNumber}&PageSize=${pageSize}&CarrearLevelId=${carrearLevel}&IsConsultant=${isConsultant}&Email=${email}&isHired=${isHired}&number=${number}&phone=${phone}&gender=${gender}&nationalityId=${nationalityId}&workPlaceId=${workPlaceId}&${managerIdQueries}&currentCompany=${currentCompany}&ReferenceBy=${referenceBy}&StartBirthDate=${startBirthDate}&EndBirthDate=${endBirthDate}&startAdmissionDate=${startAdmissionDate}&endAdmissionDate=${endAdmissionDate}&startAdmissionCTIDate=${startAdmissionCTIDate}&endAdmissionCTIDate=${endAdmissionCTIDate}&startResignationDate=${startResignationDate}&endResignationDate=${endResignationDate}&hasIntegrationEmailSent=${hasIntegrationEmailSent}&hasProfileEmailSent=${hasProfileEmailSent}&hasAssessmentSent=${hasAssessmentSent}&hasInquirySent=${hasInquirySent}&hasCorpDone=${hasCorpDone}&primaveraDepartmentId=${primaveraDepartmentId}&dismissalComment=${dismissalComment}`,
        config
    );
};

export const getEmployeeByIds = async (ids) => {
    return await httpRequest(fetchEmployeeByIds.bind(this, ids));
};

const fetchEmployeeByIds = async (ids) => {
    let config = getHttpHeaders();
    return await axios.get(`${employeeApiUrl}/GetEmployeeByIds?Ids=${ids}`, config);
};